import fieldType from '@/enums/fieldType'

export default class InputHelper {

  static getTimestampFromHours(time){
    let partOFHours=time.split(":");

    if(partOFHours.length==2){
      return partOFHours[0]*3600 + partOFHours[1]*60;
    }else if(partOFHours.length==3){
      return partOFHours[0]*3600 + partOFHours[1]*60 + partOFHours[2];
    }

    return time * 3600

  }

  static getCheckboxValue(field, id){
    return field.values.find(val => val.key == id).value
  }

  static getCheckboxStringValues(field,values){
    let res = []
    values.forEach((item) => {
      res.push(InputHelper.getCheckboxValue(field, item) )
    });
    return res.join(", ")
  }

  static getRadioObjectByKey(field,value){
      let res = field.values.find(val => val.key == value)
      return res == undefined ? "" : res.value
  }

static getRadioObjectByValue(field,value){
  return field.values.find(val => val.value == value)
}

static getRadioObjectByMatchingValue(field, value){
  return field.values.find( val => (val.value == value)
  || ( val.value.substring(0,value.length).toUpperCase() == value.toUpperCase()))
}

static getAnswer(field, value){
  if(field.type == "radio"){
    return InputHelper.getRadioObjectByKey(field,value)
  }else{
    return value
  }
}

static isEditableField(field){
  if(field.type == fieldType.TABLE || field.type == fieldType.SIGNATURE || field.type == fieldType.PHOTO){
    return false
  }
  return true;
}
}
